import axios from 'axios';
import { useCallback, useEffect, useRef } from 'react';

export const isCanceledRequest = (error: any): boolean =>
    axios.isCancel(error) || error?.code === 'ERR_CANCELED';

export const useCancelableRequest = () => {
    const controllerRef = useRef<AbortController | null>(null);

    const abortRequest = useCallback(() => {
        controllerRef.current?.abort();
        controllerRef.current = null;
    }, []);

    const createRequestSignal = useCallback((): AbortSignal => {
        abortRequest();

        const controller = new AbortController();

        controllerRef.current = controller;

        return controller.signal;
    }, [abortRequest]);

    const finishRequest = useCallback((signal: AbortSignal): boolean => {
        if (controllerRef.current?.signal !== signal) {
            return false;
        }

        controllerRef.current = null;

        return true;
    }, []);

    useEffect(() => abortRequest, [abortRequest]);

    return {
        abortRequest,
        createRequestSignal,
        finishRequest,
    };
};